export const LOCALE_KEY = 'route-breadcrumb';
